import microuniversoApi from "app/api/microuniversoApi"
import { sobrescreverInformacoesAction } from "app/redux/orcamentoSlice"
import store from "app/redux/store/store"
import { IOrcamento } from "app/types/IOrcamento"
import * as atualizacaoOrcamentoLegadoActions from 'app/redux/atualizacaoOrcamentoLegadoSlice'
import * as atualizacaoItensOrcamentoLegadoActions from 'app/redux/atualizacaoItensOrcamentoLegadoSlice'


import globalMU from "globalMU"

declare var window:any

export type DefinirPercentualDescontoAcumuladoInput = {
    percentualDescontoAcumulado: number
}

export async function definirPercentualDescontoAcumulado(input: DefinirPercentualDescontoAcumuladoInput) {
    
    try {
        globalMU.blockUI()
        
        const orcamentoAtualizado = await microuniversoApi.Orcamento.definirPercentualDescontoAcumulado(
            store.getState().orcamento.IdentificadorOrcamento,
            input.percentualDescontoAcumulado
        )
    
        const atualizarEstado = () => {
            const orcamentoLegado = window.orcamentoController.model
        
            orcamentoLegado.atualizar(orcamentoAtualizado, true, true)
    
            store.dispatch(atualizacaoOrcamentoLegadoActions.atualizar(orcamentoAtualizado))

            const atualizarEstadoItensLegado = () => {
                //const itensLegado = orcamentoLegado.get('ItensOrcamento')
    
                for(let itemAtualizado of (orcamentoAtualizado.ItensOrcamento ?? [])) {
                    //const itemLegado = itensLegado.models.find(i => i.get('Identificador') == itemAtualizado.Identificador)
                    //itemLegado.atualizar(itemAtualizado,true,true,true)
    
                    store.dispatch(atualizacaoItensOrcamentoLegadoActions.atualizarItem({
                        identificador: itemAtualizado.Identificador,
                        dadosItem: itemAtualizado
                    }))
                }
            }
    
            atualizarEstadoItensLegado()
        }
    
        atualizarEstado()
    } finally {
        globalMU.unblockUI()
    }
}